import {
  Box,
  Button,
  Chip,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import { BLUE_COLOR } from '../../../../constants/ColorsConst';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { LoadingWidget, ModalComponent } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allOperadorasAction,
  deleteOperadorasAction,
  setActivoOperadorasAction,
} from '../OperadorasAction';
import { PARAMS_MATERIAS } from '../OperadorasReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoOperadoras = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const operadorasStore = Redux.useSelector((state) => state.operadoras);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {};

      dispatch({ type: PARAMS_MATERIAS, payload });
      if (operadorasStore.all && operadorasStore.all.length === 0) {
        allOperadorasAction(dispatch, {
          ...operadorasStore.params,
          ...payload,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = operadorasStore.all.find((el) => el.id === id);
    await setActivoOperadorasAction(dispatch, data);
  };

  const _handleDeleteClick = async (id) => {
    await deleteOperadorasAction(
      dispatch,
      id,
      operadorasStore.params,
      setLoadingDelete,
    );
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.prefijo.name,
      label: CONST.prefijo.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Tooltip
                describeChild
                title="Estatus del registro"
                placement="left"
              >
                <Chip
                  label={value.nombre}
                  size="small"
                  color={value.id === 1 ? 'success' : 'error'}
                />
              </Tooltip>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Stack direction="row">
                <ActionsListWidget
                  id={tableMeta.rowData[0]}
                  onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                  onDelete={async () => {
                    const data = operadorasStore.all.find(
                      (el) => el.id === tableMeta.rowData[0],
                    );
                    await setActivoOperadorasAction(dispatch, data);
                    setOpenModalDelete(true);
                  }}
                />
              </Stack>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={operadorasStore.loadingAll || loadingDelete}
          text={loadingDelete ? 'Eliminando registro...' : 'Cargando lista...'}
        />
        <MUIDataTable
          title={'Listado'}
          data={operadorasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {operadorasStore.activo ? (
        <ModalComponent
          id="modalDeleteOperadoras"
          title={`Eliminar`}
          open={openModalDelete}
          maxWidth="sm"
          onClose={() => setOpenModalDelete(!openModalDelete)}
        >
          <Grid container spacing={1}>
            <Grid item md={12}>
              ¿Seguro que quieres eliminar esta materia?
              <br />
              <br />
              <Typography variant="h6">
                {operadorasStore.activo.nombre}
              </Typography>
            </Grid>
            <Grid item md={12} align="right">
              <Button
                color="error"
                variant="outlined"
                onClick={async () => {
                  await _handleDeleteClick(operadorasStore.activo.id);
                }}
                sx={{ mr: 2 }}
              >
                ELIMINAR
              </Button>
              <Button
                sx={{ color: BLUE_COLOR }}
                onClick={() => setOpenModalDelete(false)}
              >
                CANCELAR
              </Button>
            </Grid>
          </Grid>
        </ModalComponent>
      ) : null}
    </Grid>
  );
};

export default ListadoOperadoras;
